<div class="screen-holder">
    <section class="main-section" [style.background-image]="'url(' + (authPageBackground$ | async) + ')'">
        <section class="header-section">
            <serviceos-web-header-screen></serviceos-web-header-screen>
        </section>
    
        <section class="container content" *ngIf="!isUserAuthorized && isCoreInit && view">
            <div class="row" style="width: 100%">
                <div class="col-6 d-none d-lg-block" *ngIf="sliderData$ | async as sliderData">
                    <div class="slider-holder">
                        <serviceos-ng-carousel-slider [carouselData]="sliderData" [showNavigationArrows]="true"></serviceos-ng-carousel-slider>
                    </div>
                </div>
                <div class="col-12" [ngClass]="{'col-lg-6': sliderData$ | async}">
                    <div class="modal-holder">
                        <serviceos-web-card>
                            <ng-container *ngIf="view === 'register'">
                                <serviceos-web-tabs
                                    (changeScreenEvent)="onChangeScreen($event)"
                                    [screen]="screen"
                                ></serviceos-web-tabs>
                                <serviceos-web-register
                                    *ngIf="screen === 'create-account'"
                                    [referralParamCode]="referralCode"
                                    (changeScreenEvent)="onChangeScreen($event)"
                                ></serviceos-web-register>
                                <serviceos-web-footnote-box
                                    (changeScreenEvent)="onChangeScreen($event)"
                                ></serviceos-web-footnote-box>
                            </ng-container>
                            <ng-container *ngIf="view === 'merge'">
                                <serviceos-web-merge-account
                                    [accountData]="mergeAccountData"
                                >
                                </serviceos-web-merge-account>
                            </ng-container>
                        </serviceos-web-card>
                    </div>
                </div>
            </div>
        </section>
    </section>

    <section class="footer-section">
        <serviceos-web-footer-screen></serviceos-web-footer-screen>
    </section>
</div>
<serviceos-ng-loader></serviceos-ng-loader>
